(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BitAndBinary-google-reviews"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.testimonials-slider');
  const track = slider.querySelector('.testimonials-track');
  const slides = slider.querySelectorAll('.testimonial-slide');
  const dots = slider.querySelectorAll('.dot');
  const prevBtn = slider.querySelector('.prev-arrow');
  const nextBtn = slider.querySelector('.next-arrow');
  
  let currentIndex = 0;
  let slidesPerView = getSlidesPerView();
  let autoplayInterval;

  function getSlidesPerView() {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 1024) return 2;
    return 3;
  }

  function updateSlidesPerView() {
    slidesPerView = getSlidesPerView();
    showSlide(currentIndex);
  }

  function showSlide(index) {
    const totalSlides = slides.length;
    const maxIndex = totalSlides - slidesPerView;
    
    // Ensure index stays within bounds
    if (index > maxIndex) index = maxIndex;
    if (index < 0) index = 0;
    
    currentIndex = index;
    
    // Update track position
    const slideWidth = slides[0].offsetWidth;
    track.style.transform = `translateX(-${index * slideWidth}px)`;
    
    // Update dots
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === Math.floor(index / slidesPerView));
    });
  }

  function nextSlide() {
    showSlide(currentIndex + slidesPerView);
  }

  function prevSlide() {
    showSlide(currentIndex - slidesPerView);
  }

  // Event Listeners
  if (prevBtn) prevBtn.addEventListener('click', prevSlide);
  if (nextBtn) nextBtn.addEventListener('click', nextSlide);
  
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      showSlide(index * slidesPerView);
    });
  });

  window.addEventListener('resize', updateSlidesPerView);

  // Autoplay functionality
  if (slider.dataset.autoplay === 'true') {
    const speed = parseInt(slider.dataset.speed);
    const direction = slider.dataset.direction;
    
    autoplayInterval = setInterval(() => {
      if (direction === 'left-to-right') {
        nextSlide();
      } else {
        prevSlide();
      }
    }, speed);
    
    slider.addEventListener('mouseenter', () => {
      clearInterval(autoplayInterval);
    });
    
    slider.addEventListener('mouseleave', () => {
      autoplayInterval = setInterval(() => {
        if (direction === 'left-to-right') {
          nextSlide();
        } else {
          prevSlide();
        }
      }, speed);
    });
  }

  // Initial setup
  updateSlidesPerView();
});

  } catch(e) { console.error(e); }
})();
})();
